export default "__VITE_PUBLIC_ASSET__819195cb__"